import React, { Component } from 'react'
import { Modal } from 'antd'
import InvoiceForm from './InvoiceForm'
import BillLinesList from './BillLinesList'

class InvoiceModal extends Component {
  render() {
    const {
      visibleInvoice,
      onCancelInvoice,
      invoiceFormRef,
      invoiceBooking,
      invoicing,
      billLines,
      lines,
    } = this.props

    return (
      <Modal
        visible={visibleInvoice}
        title={'Invoice All'}
        destroyOnClose={true}
        confirmLoading={invoicing}
        onOk={invoiceBooking}
        onCancel={onCancelInvoice}
        // okButtonProps={{
        //   disabled: sum(billLines.map(d => numVal(d, 'amount.net'))) <= 0,
        // }}
        width={'90%'}
        okText={'Request Invoice'}>
        <InvoiceForm ref={invoiceFormRef} {...this.props} />
        <BillLinesList {...this.props} />
      </Modal>
    )
  }
}

InvoiceModal.propTypes = {}
InvoiceModal.defaultProps = {}

export default InvoiceModal
